var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-info-bar",class:{
    'contact-info-bar--white': _vm.variant === 'white',
    'contact-info-bar--green': _vm.variant === 'green',
  }},[_c('b-container',[_c('b-row',[_c('b-col',[_c('p',{staticClass:"contact-info-bar__text"},[_vm._v(" Dúvidas ou sugestões? Entre em contato através do email cronicasrs@saude.rs.gov.br ")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }